var map = {
	"./apple-laurel-da-DK.svg": 52119,
	"./apple-laurel-de-DE.svg": 35413,
	"./apple-laurel-en-GB.svg": 11095,
	"./apple-laurel-en-US.svg": 93196,
	"./apple-laurel-es-ES.svg": 90015,
	"./apple-laurel-es-MX.svg": 43692,
	"./apple-laurel-fr-FR.svg": 87807,
	"./apple-laurel-it-IT.svg": 27117,
	"./apple-laurel-nb-NO.svg": 52890,
	"./apple-laurel-nl-NL.svg": 84971,
	"./apple-laurel-pl-PL.svg": 62467,
	"./apple-laurel-pt-BR.svg": 91063,
	"./apple-laurel-pt-PT.svg": 80259,
	"./apple-laurel-sv-SE.svg": 50590
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69308;